export default __webpack_public_path__ + "static/barclays-84946ace90f33da2e3d2144fe064dbae.png";